var _rect, _path, _rect2, _path2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8PowerBi2021(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: "16px",
    height: "16px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 78.5,
    x: 43.5,
    y: 1,
    fill: "#dbb065"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M72,80H43V0h29V80z M44,79h27V1H44V79z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 58,
    x: 27.5,
    y: 21.5,
    fill: "#f5ce85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M56,80H27V21h29V80z M28,79h27V22H28V79z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 37,
    x: 8.5,
    y: 42.5,
    fill: "#ffeea3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M37,80H8V42h29V80z M9,79h27V43H9V79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PowerBi2021);
export default __webpack_public_path__ + "static/media/icons8-power-bi-2021.dca0268ee71d37f94747d4b0db8cf103.svg";
export { ForwardRef as ReactComponent };